import { mediaUrl } from "@/lib/appApi";

const SITE = "PAPA BERSERI NEWS";
const DEFAULT_DESC = "Portal Informasi Lingkungan Hidup Kabupaten Mimika. Berita, Edukasi, dan Aksi Nyata untuk Lingkungan.";

function setTag(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function setCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
  el.setAttribute("href", url);
}

function setJsonLd(obj) {
  let el = document.getElementById("jsonld-article");
  if (obj === null) { if (el) el.remove(); return; }
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = "jsonld-article"; document.head.appendChild(el); }
  el.textContent = JSON.stringify(obj);
}

export function setArticleMeta(art, unitName) {
  if (!art) return;
  const url = window.location.href;
  const desc = (art.meta_description || art.summary || DEFAULT_DESC).slice(0, 200);
  const title = `${art.title} — ${SITE}`;
  const image = art.featured_media_url ? mediaUrl(art.featured_media_url) : `${window.location.origin}/og-image.jpg`;
  document.title = title;
  setTag("name", "description", desc);
  setTag("property", "og:type", "article");
  setTag("property", "og:title", art.title);
  setTag("property", "og:description", desc);
  setTag("property", "og:url", url);
  if (image) setTag("property", "og:image", image);
  setTag("name", "twitter:title", art.title);
  setTag("name", "twitter:description", desc);
  if (image) setTag("name", "twitter:image", image);
  setCanonical(url);
  setJsonLd({
    "@context": "https://schema.org",
    "@type": art.content_type === "edukasi" ? "Article" : "NewsArticle",
    headline: art.title,
    description: desc,
    image: image ? [image] : undefined,
    datePublished: art.published_at,
    dateModified: art.updated_at || art.published_at,
    author: art.author_name ? { "@type": "Organization", name: art.author_name } : { "@type": "Organization", name: unitName || SITE },
    publisher: { "@type": "Organization", name: "Dinas Lingkungan Hidup Kabupaten Mimika" },
    isAccessibleForFree: true,
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
  });
}

export function resetMeta() {
  document.title = `${SITE} — Portal Informasi Lingkungan Hidup Kabupaten Mimika`;
  setTag("name", "description", DEFAULT_DESC);
  setTag("property", "og:type", "website");
  setTag("property", "og:title", SITE);
  setTag("property", "og:description", DEFAULT_DESC);
  setTag("property", "og:url", window.location.origin);
  setTag("property", "og:image", `${window.location.origin}/og-image.jpg`);
  setTag("name", "twitter:image", `${window.location.origin}/og-image.jpg`);
  setCanonical(window.location.href);
  setJsonLd(null);
}
